<div class="outerContainer">
  <div class="overlay"></div>

  <nz-card class="loginCard">
    <div class="reg-log-form-inner">
      <img
        src="/assets/images/loginLogo.png"
        alt="Mockshala Logo"
        class="login-logo"
      />

      <h2 class="loginHeader">Sign In</h2>

      <form nz-form [formGroup]="loginForm" class="login-form">
        <!-- Email -->
        <nz-form-item class="loginfld">
          <nz-form-control [nzErrorTip]="errorTplEmail">
            <input
              nz-input
              type="text"
              formControlName="email"
              placeholder="Email address"
              [readonly]="isOtpSend"
            />
            <ng-template #errorTplEmail let-control>
              <span *ngIf="control.hasError('required')">
                Email is required
              </span>
              <span *ngIf="control.hasError('pattern')">
                Enter a valid email
              </span>
            </ng-template>
          </nz-form-control>
        </nz-form-item>

        <!-- Password -->
        <nz-form-item class="loginfld">
          <nz-form-control nzErrorTip="Password is required">
            <div class="password-wrapper">
              <input
                nz-input
                [type]="show ? 'text' : 'password'"
                formControlName="password"
                placeholder="Password"
                [readonly]="isOtpSend"
              />
              <span
                class="eye-icon"
                nz-icon
                nzTheme="outline"
                [nzType]="show ? 'eye-invisible' : 'eye'"
                (click)="passwordShowHide()"
              ></span>
            </div>
          </nz-form-control>
        </nz-form-item>

        <!-- OTP -->
        <nz-form-item *ngIf="isOtpSend" class="loginfld">
          <nz-form-control nzErrorTip="OTP is required">
            <input
              nz-input
              type="text"
              formControlName="otp"
              placeholder="Enter OTP"
            />
          </nz-form-control>
        </nz-form-item>

        <!-- Resend OTP -->
        <div class="otp-info text-right" *ngIf="isOtpSend">
          <p *ngIf="!showButton">
            Resend OTP in {{ countdownInMinute }}:{{ countdownInSec }} sec
          </p>
          <button
            nz-button
            nzType="link"
            *ngIf="showButton"
            (click)="resendOTP()"
          >
            Resend OTP
          </button>
        </div>

        <!-- Buttons -->
        <button
          nz-button
          nzType="primary"
          class="login-form-button"
          *ngIf="!isOtpSend"
          [nzLoading]="isLoading"
          (click)="sendOTP()"
        >
          Log in
        </button>

        <button
          nz-button
          nzType="primary"
          class="login-form-button"
          *ngIf="isOtpSend"
          [nzLoading]="isLoading"
          (click)="submitLoginForm()"
        >
          Submit
        </button>

        <!-- Forgot password -->
        <div class="login-form-forgot">
          Forgot Password?
          <a [routerLink]="['/auth/forgot-password']">Reset</a>
        </div>
      </form>
    </div>
  </nz-card>
</div>
